__turbopack_context__.v({
  "animate": "TextButton-module-scss-module__3KVq-a__animate",
  "button": "TextButton-module-scss-module__3KVq-a__button",
  "default": "TextButton-module-scss-module__3KVq-a__default",
  "gray": "TextButton-module-scss-module__3KVq-a__gray",
  "large": "TextButton-module-scss-module__3KVq-a__large",
  "primary": "TextButton-module-scss-module__3KVq-a__primary",
  "small": "TextButton-module-scss-module__3KVq-a__small",
  "spin": "TextButton-module-scss-module__3KVq-a__spin",
  "text": "TextButton-module-scss-module__3KVq-a__text",
});
